import { BankAccount } from "./BankAccount";
import { FileDto } from "./FileDto";

export class Customer {
    /** #165: the salutation — „Herr", „Frau", „Firma". The postal address is street/zip/city. */
    salutation: string = '';
    title: string = '';
    phone: string = '';
    fax: string = '';
    id: string = '';
    customerNumber: string = '';
    firstName: string = '';
    middleName: string = '';
    lastName: string = '';
    companyName: string = '';
    street: string = '';
    city: string = '';
    zipCode: string = '';
    countryId: string = '';
    stateOrRegion: string = '';
    customerGroupId: string = '';
    fullName: string = '';
    email: string = '';
    internet: string = '';
    vatRegNo: string = '';
    taxId: string = '';
    // Backend #525: uppercase ISO 4217 currency the customer prices in. The seller-level
    // default every new listing adopts at create (derived server-side — there is no per-SKU
    // currency input anywhere). Editable on the company master data form.
    defaultCurrency: string = 'EUR';
    description: string = '';
    isCustomSellerInfoActive: boolean = false;
    isActive: boolean = false;
    invoiceType: number;
    isRetailer: boolean;
    smallBusinessP19UStG: boolean = false;
    hasLargeImage: boolean;
    bankAccount?: BankAccount;

    // Server-loaded files (with binaries). UI-state for pending changes
    // lives in customer-edit.component; the wire payload uses filesToDelete.
    files: FileDto[] = [];
}